import React, { useCallback } from 'react';
import { toast } from 'react-toastify';
import { useCreateDocumentCategory } from '@area-restrita/api-client/endpoints/document-category/document-category.gen';

import { useDialog } from '@/components/template/Dialog';

import DocumentCategoryForm, {
  IDocumentCategory,
} from './document-category-form';

const CreateDocumentCategory: React.FC = () => {
  const { handleClose } = useDialog();
  const { mutateAsync } = useCreateDocumentCategory();

  const onSubmit = useCallback(
    (data: IDocumentCategory) =>
      mutateAsync(
        { data },
        {
          onSuccess: () => {
            toast.success('Categoria de documento criada com sucesso');
            handleClose();
          },
          onError: () => {
            toast.error('Erro ao criar categoria de documento');
          },
        },
      ),
    [handleClose, mutateAsync],
  );

  return <DocumentCategoryForm onSubmit={onSubmit} />;
};

export default CreateDocumentCategory;
